import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
function normalizeIcon(icon) {
  if (!icon) return 'fas fa-circle';
  if (icon.includes(' ')) return icon;
  return "fas fa-".concat(icon);
}
function extractItem(vnode) {
  var _children$find;
  if (!vnode || typeof vnode !== 'object') return null;
  const attrs = vnode.attrs;
  if (!attrs || typeof attrs !== 'object') return null;
  const children = Array.isArray(vnode.children) ? vnode.children : vnode.children != null ? [vnode.children] : [];
  return {
    icon: normalizeIcon(attrs.icon || ''),
    label: (_children$find = children.find(c => c != null && typeof c !== 'symbol')) != null ? _children$find : null,
    href: attrs.href,
    onclick: typeof attrs.onclick === 'function' ? attrs.onclick : undefined,
    isPrimary: typeof attrs.className === 'string' && attrs.className.includes('Button--primary'),
    isDisabled: attrs.disabled === true,
    isActive: attrs.active === true
  };
}
function renderItem(data, key, prefix) {
  if (!data) return null;
  const icon = data.icon,
    label = data.label,
    href = data.href,
    onclick = data.onclick,
    isPrimary = data.isPrimary,
    isDisabled = data.isDisabled,
    isActive = data.isActive;
  const cls = [prefix, isPrimary && "".concat(prefix, "--primary"), isActive && "".concat(prefix, "--active"), isDisabled && "".concat(prefix, "--disabled")].filter(Boolean).join(' ');
  const inner = m('[', null, m("span", {
    className: "".concat(prefix, "-icon"),
    "aria-hidden": "true"
  }, m("i", {
    className: "icon ".concat(icon)
  })), m("span", {
    className: "".concat(prefix, "-label")
  }, label));
  if (href) {
    return m("a", {
      key: key,
      className: cls,
      href: href,
      onclick: e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        m.route.set(href);
      }
    }, inner);
  }
  return m("button", {
    key: key,
    type: "button",
    className: cls,
    disabled: isDisabled,
    onclick: onclick
  }, inner);
}
class BentoSlider {
  constructor() {
    _defineProperty(this, "track", null);
    _defineProperty(this, "canLeft", false);
    _defineProperty(this, "canRight", false);
    _defineProperty(this, "handleScroll", () => this.updateArrows());
  }
  updateArrows() {
    if (!this.track) return;
    const _this$track = this.track,
      scrollLeft = _this$track.scrollLeft,
      scrollWidth = _this$track.scrollWidth,
      clientWidth = _this$track.clientWidth;
    this.canLeft = scrollLeft > 1;
    this.canRight = scrollLeft + clientWidth < scrollWidth - 1;
    m.redraw();
  }
  oncreate(_ref) {
    let dom = _ref.dom;
    this.track = dom.querySelector('.Bento-slider-track');
    if (this.track) {
      this.track.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
      this.updateArrows();
    }
  }
  onremove() {
    var _this$track2;
    (_this$track2 = this.track) == null || _this$track2.removeEventListener('scroll', this.handleScroll);
    this.track = null;
  }
  scroll(dir) {
    if (!this.track) return;
    const _this$track3 = this.track,
      scrollLeft = _this$track3.scrollLeft,
      clientWidth = _this$track3.clientWidth,
      scrollWidth = _this$track3.scrollWidth;
    const max = scrollWidth - clientWidth;
    const target = dir > 0 ? Math.min(scrollLeft + clientWidth, max) : Math.max(scrollLeft - clientWidth, 0);
    this.track.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  }
  view(_ref2) {
    let attrs = _ref2.attrs;
    const cls = ['Bento-slider', attrs.pillShape === 'rounded' && 'Bento-slider--rounded'].filter(Boolean).join(' ');
    return m("div", {
      className: cls
    }, this.canLeft && m("button", {
      type: "button",
      className: "Bento-slider-arrow Bento-slider-arrow--left",
      onclick: () => this.scroll(-1),
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-chevron-left"
    })), m("div", {
      className: "Bento-slider-track"
    }, attrs.items.map(_ref3 => {
      let data = _ref3.data,
        key = _ref3.key;
      return renderItem(data, key, 'Bento-pill');
    })), this.canRight && m("button", {
      type: "button",
      className: "Bento-slider-arrow Bento-slider-arrow--right",
      onclick: () => this.scroll(1),
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-chevron-right"
    })));
  }
}
app.initializers.add('forumaker-bento', () => {
  override(IndexSidebar.prototype, 'view', function (original) {
    var _window$matchMedia, _window;
    if (!TagsPage || !app.current.matches(TagsPage)) return original();
    if ((_window$matchMedia = (_window = window).matchMedia) != null && (_window$matchMedia = _window$matchMedia.call(_window, '(max-width: 768px)')) != null && _window$matchMedia.matches) return original();
    const cols = Number(app.forum.attribute('forumaker-bento.columns_desktop') || 4);
    const layout = app.forum.attribute('forumaker-bento.layout') || 'tiles';
    const pillShape = app.forum.attribute('forumaker-bento.pill_shape') || 'capsule';
    const plainCreate = app.forum.attribute('forumaker-bento.plain_create_button');
    const newDiscData = extractItem(this.items().get('newDiscussion'));
    if (newDiscData && plainCreate) newDiscData.isPrimary = false;
    const allItems = [];
    if (newDiscData) allItems.push({
      data: newDiscData,
      key: 'newDiscussion'
    });
    for (const _ref4 of this.navItems().toArray().entries()) {
      var _ref5 = _slicedToArray(_ref4, 2);
      const i = _ref5[0];
      const vnode = _ref5[1];
      const d = extractItem(vnode);
      if (d) allItems.push({
        data: d,
        key: "nav-".concat(i)
      });
    }
    const navClass = 'IndexPage-sidebar Bento-sidebar';
    if (layout === 'slider') {
      return m("nav", {
        className: navClass
      }, m(BentoSlider, {
        items: allItems,
        pillShape
      }));
    }
    if (layout === 'pills') {
      const containerClass = ['Bento-pills', pillShape === 'rounded' && 'Bento-pills--rounded'].filter(Boolean).join(' ');
      return m("nav", {
        className: navClass,
        style: {
          '--bento-cols': String(cols)
        }
      }, m("div", {
        className: containerClass
      }, allItems.map(_ref6 => {
        let data = _ref6.data,
          key = _ref6.key;
        return renderItem(data, key, 'Bento-pill');
      })));
    }
    return m("nav", {
      className: navClass,
      style: {
        '--bento-cols': String(cols)
      }
    }, m("div", {
      className: "Bento-grid"
    }, allItems.map(_ref7 => {
      let data = _ref7.data,
        key = _ref7.key;
      return renderItem(data, key, 'Bento-tile');
    })));
  });
});